export default defineNuxtPlugin((nuxtApp) => {
	const isOnline = useState('isOnline', () => navigator.onLine)

	const updateOnlineStatus = () => {
		isOnline.value = navigator.onLine
	}

	window.addEventListener('online', updateOnlineStatus)
	window.addEventListener('offline', updateOnlineStatus)

	updateOnlineStatus()
})
